import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { DEBUG_BUILD } from '../debug-build.js';
import { SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE, SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT } from '../semanticAttributes.js';
import { logger } from '../utils-hoist/logger.js';
import { getRootSpan, getActiveSpan } from '../utils/spanUtils.js';

/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */
function setMeasurement(name, value, unit) {
  var activeSpan = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : getActiveSpan();
  var rootSpan = activeSpan && getRootSpan(activeSpan);
  if (rootSpan) {
    var _rootSpan$addEvent;
    DEBUG_BUILD && logger.log("[Measurement] Setting measurement on root span: ".concat(name, " = ").concat(value, " ").concat(unit));
    rootSpan.addEvent(name, (_rootSpan$addEvent = {}, _defineProperty(_rootSpan$addEvent, SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE, value), _defineProperty(_rootSpan$addEvent, SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT, unit), _rootSpan$addEvent));
  }
}

/**
 * Convert timed events to measurements.
 */
function timedEventsToMeasurements(events) {
  if (!events || events.length === 0) {
    return undefined;
  }
  var measurements = {};
  events.forEach(function (event) {
    var attributes = event.attributes || {};
    var unit = attributes[SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
    var value = attributes[SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];
    if (typeof unit === 'string' && typeof value === 'number') {
      measurements[event.name] = {
        value: value,
        unit: unit
      };
    }
  });
  return measurements;
}
export { setMeasurement, timedEventsToMeasurements };